import { getColors } from "../../../jss_setup/colors";

export const footer = {
  footer: {
    background: "#221C34",
  },
};
